// Default backend URL (used as fallback)
// const DEFAULT_BACKEND_URL = "http://localhost:4000/api";
const DEFAULT_BACKEND_URL = "https://api.parcels.shypv.com/api";
// const DEFAULT_BACKEND_URL = process.env.REACT_APP_SERVER_URL;

// Get backend URL from selected country or use default
export const getBackendUrl = () => {
    try {
        const selectedCountry = localStorage.getItem('selectedCountry');
        if (selectedCountry) {
            const country = JSON.parse(selectedCountry);
            if (country.apiUrl) {
                return country.apiUrl;
            }
        }
    } catch (error) {
        console.error('Error getting backend URL from country config:', error);
    }
    return DEFAULT_BACKEND_URL;
};

// For backward compatibility, export default URL
const BACKEND_URL = getBackendUrl();

export default BACKEND_URL;